import * as React from "react";
import type { SVGProps } from "react";
const SvgIconFavorite = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" {...props}><path d="M 211.84345,-69.064528 480.01481,-230.81869 748.18617,-66.936184 677.95082,-373.41775 914.19702,-577.73879 603.45877,-605.40726 480.01481,-894.86207 356.57085,-607.53561 45.832601,-579.86713 282.0788,-373.41775 Z" style={{
    stroke: "#7f7f7f",
    strokeWidth: 75
  }} /></svg>;
export default SvgIconFavorite;